import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CoachingDifficulty } from '@euler/model/coaching';
import { RotateCcw, TrendingUp } from 'lucide-react-native';
import { memo } from 'react';
import { View } from 'react-native';
import { levelName } from '../../../copy';
import { AgainButton } from './AgainButton';

/** 再练一次, and 升一级 beside it once the next level is open. */
export const AgainButtons = memo(
  ({
    againTitle,
    levelUp,
    busy,
    onAgain,
  }: {
    againTitle: string;
    levelUp: CoachingDifficulty | null;
    busy: 'again' | 'level_up' | null;
    onAgain: (levelUp: boolean) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View style={{ flexDirection: 'row', gap: rpx(10) }}>
        <AgainButton
          title={againTitle}
          icon={RotateCcw}
          primary
          busy={busy === 'again'}
          disabled={!!busy}
          onPress={() => onAgain(false)}
        />
        {levelUp != null ? (
          <AgainButton
            title={`升一级 · ${levelName(levelUp)}`}
            icon={TrendingUp}
            primary={false}
            busy={busy === 'level_up'}
            disabled={!!busy}
            onPress={() => onAgain(true)}
          />
        ) : null}
      </View>
    );
  },
);
